<div class="d-flex flex-column flex-fill dx-card">
  <div class="d-flex mt-3 ms-3">
    <dx-form [formData]="filter" style="max-width: 150px">
      <dxi-form-item dataField="startDate" editorType="dxDateBox"></dxi-form-item>
      <dxi-form-item dataField="endDate" editorType="dxDateBox"></dxi-form-item>
    </dx-form>
    <div class="d-flex flex-column ms-3 mt-3">
      <button class="btn btn-secondary" (click)="toggleShowPreviousWeek()">
        {{ showPreviousWeek ? 'This Week' : 'Previous Week' }}
      </button>
      <button class="btn btn-primary mt-2" (click)="getData()">Search</button>
    </div>
    @if (!!feeRevenue) {
      <div class="summary-table">
        <table class="table">
          <thead>
            <h4 style="text-align: center">Fee Revenue</h4>
            <tr>
              <th>Name</th>
              <th>First</th>
              <th>Last</th>
              <th>Count</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            @for (revenue of feeRevenue; track revenue) {
              <tr>
                <td class="table-little-padding">{{ revenue.name }}</td>
                <td class="table-little-padding">{{ revenue.first | date : 'shortDate' }}</td>
                <td class="table-little-padding">{{ revenue.last | date : 'shortDate' }}</td>
                <td class="table-little-padding total-right-align">{{ revenue.count | number }}</td>
                <td class="table-little-padding total-right-align">{{ revenue.total | currency }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="flex-row flex-fill d-flex pt-3">
    <div class="d-flex flex-fill flex-column pb-2 px-2">
      <h4 class="mx-2 my-0">Customer Totals</h4>
      <dx-data-grid
        #customerTotalsGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="350px"
        [dataSource]="customerTotals"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="customer" width="300"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceCount" caption="Invoices" width="100" cellTemplate="invoiceTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rentalCount" caption="Rentals" width="100" cellTemplate="rentalTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column
          dataField="averageMargin"
          caption="Average Rental Margin for Selected Date Range"
          width="150"
          [format]="{ type: 'percent', precision: 2 }"
        ></dxi-data-grid-column>
        <dxi-data-grid-column
          dataField="allTimeAvgMargin"
          caption="All Time Average Rental Margin (since 5/1/2025)"
          width="150"
          [format]="{ type: 'percent', precision: 2 }"
        ></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobCount" caption="Jobs" width="100" cellTemplate="jobTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column
          dataField="avgJobMargin"
          caption="Average Job Margin for Selected Date Range"
          width="150"
          [format]="{ type: 'percent', precision: 2 }"
        ></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'invoiceTemplate'">
          @if (cell.data) {
            <a [routerLink]="[]" (click)="viewInvoices(cell.data.id)">{{ cell.text }}</a>
          }
        </div>

        <div *dxTemplate="let cell of 'rentalTemplate'">
          @if (cell.data) {
            <a [routerLink]="[]" (click)="viewRentals(cell.data.id)">{{ cell.text }}</a>
          }
        </div>

        <div *dxTemplate="let cell of 'jobTemplate'">
          @if (cell.data) {
            <a [routerLink]="[]" (click)="viewJobs(cell.data.id)">{{ cell.text }}</a>
          }
        </div>

        <dxo-data-grid-summary>
          <dxi-data-grid-total-item column="total" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-data-grid-total-item>
        </dxo-data-grid-summary>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="report-customer-totals-grid"></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            class="btn btn-primary me-1 mb-2"
            (click)="viewInvoices(customerTotalsGrid.instance.getSelectedRowsData()[0].id)"
            [disabled]="customerTotalsGrid.instance.getSelectedRowsData().length !== 1"
            >
            View Invoices
          </button>
          <button
            class="btn btn-primary me-1 mb-2"
            (click)="viewRentals(customerTotalsGrid.instance.getSelectedRowsData()[0].id)"
            [disabled]="customerTotalsGrid.instance.getSelectedRowsData().length !== 1"
            >
            View Rentals
          </button>
          <button
            class="btn btn-primary me-4 mb-2"
            (click)="viewJobs(customerTotalsGrid.instance.getSelectedRowsData()[0].id)"
            [disabled]="customerTotalsGrid.instance.getSelectedRowsData().length !== 1"
            >
            View Jobs
          </button>
          <button
            class="btn btn-primary mb-2"
            (click)="recalcMargins(customerTotalsGrid.instance.getSelectedRowsData())"
            [disabled]="customerTotalsGrid.instance.getSelectedRowsData().length === 0"
            >
            Recalculate Margin
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (customerTotals) {
            <span class="me-3">
              <strong>{{ customerTotalsGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
